import "@sanity/vision/bundle.css";
import { n as visionUsEnglishLocaleBundle } from "./i18n-t8J2mRUI.js";
import { EyeOpenIcon } from "@sanity/icons/EyeOpen";
import { lazy } from "react";
import { definePlugin } from "sanity";
import { route } from "sanity/router";
const visionTool = definePlugin((options) => {
	let { name, title, icon, ...config } = options || {};
	return {
		name: "@sanity/vision",
		tools: [{
			name: name || "vision",
			title: title || "Vision",
			icon: icon || EyeOpenIcon,
			component: lazy(() => import("./SanityVision-THRvKATp.js")),
			options: config,
			router: route.create("/*"),
			__internalApplicationType: "sanity/vision"
		}],
		i18n: { bundles: [visionUsEnglishLocaleBundle] }
	};
});
export { visionTool };

//# sourceMappingURL=index.js.map